import { loadScript, cookie, storage } from '../base/base';
import copy from 'copy-to-clipboard';

const ua = typeof navigator === 'object' ? navigator.userAgent.toLocaleLowerCase() : '';
const uaMsg = {
    isWhere: reg => {
        return ua.match(reg);
    },
    weixin: ua.match(/micromessenger/gi),
    isWeibo: ua.match(/weibo/i),
    QQ: ua.match(/qq\//),
    isAndroid: ua.match(/android/gi),
    isIos: ua.match(/iphone|ipod/gi),
    isIpad: ua.match(/ipad/gi),
    wxosEdition: () => {
        const reg = /([1-9]?[0-9])_([0-9])/gi;
        const iosarr = reg.exec(ua);

        if (iosarr != null && (this.isIos || this.isIpad) && iosarr.length >= 3) {
            return iosarr[1];
        } else {
            return 0;
        }
    },
};

const platForm = () => {
    if (uaMsg.weixin) {
        return 'inter|wx_';
    } else if (uaMsg.QQ) {
        return 'inter|qq_';
    } else if (uaMsg.isWeibo) {
        return 'inter|wb_';
    } else {
        return 'inter|other_';
    }
};

const oToS = (p, noPrefixKind) => {
    const arr = [];

    for (const n of Object.keys(p)) {
        if (!p[n]) continue;
        if (n === 'secretCallUp' || n === 'gourl' || n === 'noPrefixKind') continue;
        if (n === 'kind') {
            if (noPrefixKind) {
                arr.push(`${n}=${p[n]}`);
            } else {
                arr.push(`${n}=${platForm()}${p[n]}`);
            }
        } else {
            arr.push(`${n}=${p[n]}`);
        }
    }
    if (uaMsg.isAndroid) {
        arr.push(`timeStamp=${new Date().getTime()}`);
    }

    return arr.join('&');
};

let isFirstEntry = true;
const isCloseGuideFixed = () => {
    if (location.href.indexOf('weiboGuideFixed=1') === -1) {
        location.href = `${location.href}#weiboGuideFixed=1`;
    }
    const guideFixed = document.querySelector('#guideFixed');

    guideFixed.addEventListener('click', () => {
        if (location.href.indexOf('weiboGuideFixed=1') !== -1 && guideFixed) {
            history.back();
        }
    });
    if (isFirstEntry) {
        isFirstEntry = false;
        window.addEventListener('hashchange', () => {
            const guideChangeFixed = document.querySelector('#guideFixed');

            if (location.href.indexOf('weiboGuideFixed=1') === -1 && guideChangeFixed) {
                guideChangeFixed.parentNode.removeChild(guideChangeFixed);
            }
        });
    }
};

const callNewsAPP = (base, params) => {
    const coldCall = document.createElement('img');
    const coldCallId = `${decodeURIComponent(params.id)}&${oToS({
        kind: params.kind,
    })}`;

    coldCall.src = `http://api.iclient.ifeng.com/shareArticle?type=${params.type}&id=${encodeURIComponent(coldCallId)}`;

    coldCall.id = 'coldImg';
    coldCall.style.display = 'none';
    document.body.appendChild(coldCall);

    setTimeout(() => {
        document.body.removeChild(coldCall);
    }, 500);

    const openPath = `wakeupiOS/${base.openPath || 'ifengnews'}`;
    const download = base.download || 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367873683475';
    const downloadAd = base.downloadAd || '';
    const ucStopover = base.ucStopover || 'https://ishare.ifeng.com/ucTransfer?';
    const protocolApi = base.protocolApi || 'comifengnewsclient://call';
    const domainApi = base.domainApi || 'https://i.ifeng.com/';
    const noPrefixKind = params.noPrefixKind || '';

    let noDown = null;

    if (base.downloadAd && base.download) {
        noDown = true;
    }
    const paramsPath = typeof params === 'object' ? `?${oToS(params, noPrefixKind)}` : '';

    let url = '';

    // 微博逻辑特殊处理
    if (uaMsg.isWeibo) {
        setTimeout(() => {
            if (!document.hidden) {
                document
                    .querySelector('body')
                    .insertAdjacentHTML(
                        'beforeend',
                        '<section id="guideFixed" style="position: fixed;width: 100%;height: 100%;top: 0; left: 0;background: #ececec; z-index:99999;"><img style="width:100%" src ="http://p2.ifengimg.com/ifengimcp/pic/20190507/21ab0fc3fd400f8e387e_size58_w750_h1334.png"></secton>',
                    );
            }

            isCloseGuideFixed();
        }, 500);

        return false;
    }
    /*
    *复制剪切板
    * */
    if (uaMsg.isIos || uaMsg.isIpad) {
        // let urls = '';

        if (params.secretCallUp && params.gourl) {
            if (storage.getSession('calluped')) {
                location.href = params.gourl;

                return false;
            }
            storage.setSession('calluped', 1);
            setTimeout(() => {
                location.href = `${domainApi}${openPath}/call${paramsPath}&gourl=${encodeURIComponent(
                    params.gourl,
                )}&remind=1`;
            }, 10);

            return false;
        }

        if (params.gourl) {
            location.href = `${domainApi}${openPath}/call${paramsPath}&gourl=${encodeURIComponent(
                params.gourl,
            )}&remind=1`;

            return false;
        }

        if (uaMsg.weixin) {
            location.href = `${domainApi}${openPath}/call${paramsPath}&remind=1`;

            return false;
        }
        // 转发进入 非扫码进入
        if (uaMsg.QQ) {
            copy(protocolApi + paramsPath);
            location.href = `${domainApi}${openPath}/call${paramsPath}&remind=1`;

            return false;
        }

        if (ua.indexOf('ucbrowser') > 0 && ua.indexOf('baidubrowser') === -1) {
            copy(protocolApi + paramsPath);
            url = protocolApi + paramsPath;
            location.href = download;

            return false;
        } else {
            let paramsPaths = paramsPath.replace('?', '');

            // url = `${domainApi}${openPath}/call${paramsPath}`;
            // urls = `${domainApi}${openPath}/call${paramsPath}&remind=1`;
            url = `${domainApi}${openPath}/call${paramsPath}&remind=1`;
        }
        // location.href = url;

        setTimeout(() => {
            // location.href = urls;
            location.href = url;
        });
    } else {
        if (params.secretCallUp && params.gourl) {
            if (storage.getSession('calluped')) {
                location.href = params.gourl;

                return false;
            }
            storage.setSession('calluped', 1);
            location.href = protocolApi + paramsPath;

            setTimeout(() => {
                location.href = params.gourl;
            }, 1000);

            return false;
        }

        if (params.gourl) {
            location.href = protocolApi + paramsPath;

            setTimeout(() => {
                location.href = params.gourl;
            }, 1000);

            return false;
        }
        if (uaMsg.weixin || uaMsg.QQ) {
            copy(protocolApi + paramsPath);
            url = `${download}&android_scheme=${encodeURIComponent(protocolApi + paramsPath)}`;
            location.href = url;

            return false;
        } else if (
            (ua.indexOf('ucbrowser') > 0 || ua.indexOf('u;') > 0) &&
            ua.indexOf('miuibrowser') === -1 &&
            ua.indexOf('vivobrowser') === -1 &&
            ua.indexOf('mqqbrowser') === -1
        ) {
            url = ucStopover + protocolApi + paramsPath;
        } else {
            url = protocolApi + paramsPath;
        }
        location.href = url;

        if (document.hasFocus() && noDown) {
            setTimeout(() => {
                location.href = downloadAd;
            }, 150);
        }
    }
};

// 拉起拉活
const handleCallNewsApp = (nodata, docType, aid, toUrl, comment, userId, kind, others = {}, downloads = {}) => {
    // 不需要用encodeURIComponent的数组，直接发id
    const NoEncodeURIComponentType = ['zmt', 'source', 'hotspotlist', 'hotspotnew'];
    const isSendId = NoEncodeURIComponentType.indexOf(docType) >= 0;
    const downloadDefault = {
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354553159819', // 应用宝地址
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905', // 广告下载地址
        domainApi: 'https://api.iclient.ifeng.com/',
    };
    const downloadFormal = Object.assign(downloadDefault, downloads);

    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

    // 拉新拉活
    const sharenews_dataApi = `https://${nineDomain}/GetNewsDocs`;
    const topic_dataApi = 'https://api.iclient.ifeng.com/TopicApiForCmpp';
    const vampire_dataApi = 'https://api.iclient.ifeng.com/api_vampire_article_detail?gv=5.5.5&doc=1';
    // 新专题
    const topic3_dataApi = `https://${nineDomain}/newTopic`;
    let doc_type = 'doc';
    let ll = '';

    if (nodata === 'nodata') {
        // 品牌
        doc_type = 'awake';
    } else {
        doc_type = docType;

        if (doc_type === 'phvideo' || doc_type === 'video') {
            doc_type = 'phvideo';
            ll = aid;
        } else if (doc_type === 'vampire') {
            doc_type = 'doc';

            ll = `${vampire_dataApi}&aid=${aid}`;
        } else if (doc_type === 'web') {
            ll = aid;
        } else if (doc_type === 'topic2' || doc_type === 'topic') {
            ll = `${topic_dataApi}?topicid=${aid}&json=y`;
        } else if (doc_type === 'topic3') {
            ll = `${topic3_dataApi}?topicid=${aid}&json=y`;
        } else if (doc_type === 'short' || doc_type === 'article') {
            doc_type = 'doc';
            ll = `${sharenews_dataApi}?aid=${aid}`;
        } else {
            ll = `${sharenews_dataApi}?aid=${aid}`;
        }
    }

    callNewsAPP(
        {
            ...downloadFormal,
        },
        {
            type: doc_type, // 拉起类型
            kind: kind || 'sf_downopen', // 拉起统计
            ref: docType === 'hotspotlist' ? aid : encodeURIComponent(decodeURIComponent(location.href)), // 端内地址
            id: isSendId ? aid : encodeURIComponent(decodeURIComponent(ll)), // 端内地址
            /**
             * 拉起视频不自动播放
             *  */
            playState: 1,
            /**
             * 拉起评论页
             *  */
            comment: comment || '',
            userId: userId || '',
            ...others,
        },
    );
};

const getScript = async (url, callback) => {
    await loadScript(url, { cache: false, reload: false });

    if (callback) callback();
};

const getUserid = () => {
    return cookie.get('userid');
};

const getSid = () => {
    return cookie.get('sid');
};

export { callNewsAPP, handleCallNewsApp, getScript, getUserid, getSid };
